import { managerOnly } from '@/pages/admin/registryCycle.mjs'

export function permissionRout(to,store) {
	const roleName = store.state.user.user?.role?.name || store.state.user.role?.name
	if (to.meta.registryManagerOnly && !managerOnly(roleName)) {
		return { path: '/' }
	}

	if (to.meta.isAdmin && store.state.user.role.id < 2){
		return {
			path:'/',
			query: { redirect: to.fullPath },
		}
	}
	if (to.meta.adminOnly) {
		const allowedRoles = ['superadmin','Админ','Руководитель','Руководитель отдела']
		if (!allowedRoles.includes(roleName)){
			return {
				path:'/',
				query: { redirect: to.fullPath },
			}
		}
	}
	if (to.meta.nonGuestOnly && (!roleName || roleName === 'Гость')){
		return {
			path:'/',
			query: { redirect: to.fullPath },
		}
	}
	if (to.meta.permission && !store.getters.hasPermission(to.meta.permission)){
		return {
			path:'/',
			query: { redirect: to.fullPath },
		}
	}
	// Любое из прав (any-of): например AI-страницы — ai_agent.use ИЛИ statistics.general.
	if (Array.isArray(to.meta.permissionAny)
		&& !to.meta.permissionAny.some((p) => store.getters.hasPermission(p))){
		return {
			path:'/',
			query: { redirect: to.fullPath },
		}
	}
}
